
import { mapActions } from 'vuex';

export default {
  name: 'AppFacebookPost',
  props: {
    review: { type: Object, required: true }
  },
  mounted() {
    this.initFacebook();
  },
  methods: {
    ...mapActions('facebook', ['initFacebook'])
  }
};
